import { useEffect, useState } from 'react';

import apiToken, {
  handleApiError,
  isSuccess,
} from '@/shared/services/axiosInstance';
import { useAuthStore } from '@/shared/stores/useAuthStore';

import { ContactUsForm } from '../types/ContactUsFormTypes';

export const useGetUserInfo = (
  setContactUsForm: React.Dispatch<React.SetStateAction<ContactUsForm>>,
) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const [userInfoFetched, setUserInfoFetched] = useState(false);

  const getUserInfo = async () => {
    try {
      const response = await apiToken.get('/api/v1/user');

      if (isSuccess(response.data)) {
        setContactUsForm((prev) => ({
          ...prev,
          companyName: response.data.data.companyName || '',
          representativeName: response.data.data.representativeName || '',
          businessRegistrationNumber:
            response.data.data.businessRegistrationNumber || '',
        }));
        // 값이 있으면 disabled 처리
        if (
          response.data.data.companyName ||
          response.data.data.representativeName ||
          response.data.data.businessRegistrationNumber
        ) {
          setUserInfoFetched(true);
        }
      }
    } catch (error) {
      const errorMessage = handleApiError(error);
      console.error('Failed to fetch user info:', errorMessage);
      alert('Failed to load your information. Please enter it manually.');
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      getUserInfo();
    }
  }, [isAuthenticated]);

  return { userInfoFetched };
};
